'use client'

import { createContext, useContext, type ReactNode } from 'react'
import type { ProductCreationContractId } from '@/contracts/productCreation'
import type { RowVariantMetadataRegistry } from '../rowTemplates/RowTemplateTypes'

export type ProductSurfacePath =
  | 'std'
  | 'mailbox'
  | 'forum'
  | 'gallery'
  | 'site'
  | 'contacts'
  | 'poo'
  | 'gallery2'
  | 'flickr'
  | 'instagram'
  | 'gmail'
  | 'twitter'
  | 'facebook'
  | 'hackernews'
  | 'fullscreen'
  | 'cards'
  | 'notes'
  | 'presentation'
  | 'tiles'
  | 'wiki'
  | 'email'
  | 'musicbox'
  | 'musictrack'
  | 'portal'

export interface ProductDisplayDefinition {
  path: ProductSurfacePath
  comboValue: number
  dbMarker: string
  runtimeMsgType: string
  label: string
  createContract: ProductCreationContractId
  settingsSelectable: boolean
  /** Transport/system-owned path: never shown as a create/configure choice. */
  internalOnly?: boolean
  rowVariants?: RowVariantMetadataRegistry
}

export type ProductDisplayCatalog = readonly ProductDisplayDefinition[]

const ProductDisplayCatalogContext = createContext<ProductDisplayCatalog | null>(null)

export function ProductDisplayCatalogProvider({
  value,
  children,
}: {
  value: ProductDisplayCatalog
  children: ReactNode
}) {
  return <ProductDisplayCatalogContext.Provider value={value}>{children}</ProductDisplayCatalogContext.Provider>
}

export function useProductDisplayCatalog(): ProductDisplayCatalog {
  const value = useContext(ProductDisplayCatalogContext)
  if (!value) throw new Error('Product Display catalog provider is missing')
  return value
}
